module.exports = __webpack_public_path__ + "4aa4c2960cdfdf88da4ca3f8a08b85e1.svg";